import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EnterpriseData } from '../../../entity/entity.types';
import { EvolutionChart } from '../../../entity/charts/evolution/EvolutionChart';
import { EntityInfos } from '../../../entity/expertises/infos/EntityInfos';
import { WhoCanSeeThis } from './WhoCanSeeThis';
import { openNewTab } from '../../../utils/domUtils';
import { DataSet } from '../../../entity/charts/getLineChartConfig';
import { wantToOpenInNewTabVanillaEvent } from '../../../utils/linkUtils';
import { getPageName } from '../../../utils/pageName';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../../entity/components/EntityBlockComponents';

type Props = {
  enterpriseDatas: EnterpriseData;
  oppositesEnterpriseDatas: Array<EnterpriseData>;
  decisionCount: number;
};

export const EvolutionChartCard: FC<Props> = ({
  enterpriseDatas,
  oppositesEnterpriseDatas,
  decisionCount,
}) => {
  const onChartClick = (
    event: MouseEvent,
    data: DataSet & {
      customMetadatas?: { raisonSociale: string; enterpriseId: string };
    },
    year: string,
  ) => {
    if (data.customMetadatas) {
      const { raisonSociale, enterpriseId } = data.customMetadatas;
      const url = buildUrlWithParameters('/search', {
        q: `${encodeURIComponent(raisonSociale)} en ${year}`,
        eid: enterpriseId,
        source: 'evolution_contentieux',
        sourcePage: getPageName(),
      });

      if (wantToOpenInNewTabVanillaEvent(event)) {
        openNewTab(url);
      } else {
        window.location.href = url;
      }
    }
  };

  return (
    <EntityBlock>
      <div className="entity__block__value-line">
        <EntityBlockTitle>
          <FormattedMessage
            id={
              oppositesEnterpriseDatas.length > 0
                ? 'app.pages.enterprise.chart.opponents'
                : 'app.pages.enterprise.chart.years'
            }
          />
        </EntityBlockTitle>
        <WhoCanSeeThis />
      </div>
      <EntityInfos
        decisionCount={decisionCount}
        entityType="enterprise"
        entityName={enterpriseDatas.raisonSociale}
      />
      <div className="entity__chart">
        <EvolutionChart
          enterpriseDatas={enterpriseDatas}
          oppositesEnterpriseDatas={oppositesEnterpriseDatas}
          handleClick={onChartClick}
        />
      </div>
    </EntityBlock>
  );
};
